import * as React from 'react'

const QueIcon = () => {
  return (
    <svg
      width="15"
      height="16"
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.72667 5.99998C5.8834 5.55442 6.19277 5.17872 6.59997 4.9394C7.00717 4.70009 7.48593 4.61261 7.95145 4.69245C8.41697 4.7723 8.83921 5.01433 9.14339 5.37567C9.44756 5.737 9.61404 6.19433 9.61333 6.66665C9.61333 7.99998 7.61333 8.66665 7.61333 8.66665M7.66667 11.3333H7.67333M14.3333 7.99998C14.3333 11.6819 11.3486 14.6666 7.66667 14.6666C3.98477 14.6666 1 11.6819 1 7.99998C1 4.31808 3.98477 1.33331 7.66667 1.33331C11.3486 1.33331 14.3333 4.31808 14.3333 7.99998Z"
        stroke="#475467"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default QueIcon
